// exported for testing
export const NON_DISPLAYABLE_GROUP_NAMES = ['COMPANY_ADMIN', 'COMPANY_OWNER', 'DEVELOPER', 'AGENT'];
export function filterNonDisplayableGroupNames(groups) {
    return groups.filter(({ name }) => {
        return name != null && !NON_DISPLAYABLE_GROUP_NAMES.includes(name.toUpperCase());
    });
}
//# sourceMappingURL=filter_nondisplayable_group_names.js.map